import { collection, doc, getDocs, getDoc, limit, query, where } from "firebase/firestore";
import { db } from "../firebase";

// Record doc ID can drift from users.employeeId (e.g. ID edited later), so fall back to the uid field.
export async function resolveEmployeeRecordRef(employeeId, uid) {
  const primary = doc(db, "employee_records_complete", employeeId || uid);
  const snap = await getDoc(primary);
  if (snap.exists() || !uid) return { ref: primary, snap };

  const q = query(collection(db, "employee_records_complete"), where("uid", "==", uid), limit(1));
  const found = await getDocs(q);
  if (!found.empty) return { ref: found.docs[0].ref, snap: found.docs[0] };
  return { ref: primary, snap };
}
